<td-wb-range-selector-calendar
  id="range-selector-calendar-5"
  [calendarStyle]="calendarStyle"
  #picker>
  @if (calendarStyle === 'regular') {
    <ng-container *ngTemplateOutlet="picker.dateContent()" />
  }
  <td-wb-form (submitAction)="onCustomRangeSubmit()">
    <div class="td-wb-date-range-picker__row-wrapper">
      <td-wb-form-row class="td-wb-date-range-picker__row td-wb-date-range-picker__row--first">
        <td-wb-input-group labelPosition="top">
          <td-wb-input-group-label>
            <label for="range-selector-calendar-from-1"
                   translate="tdWb.calendar.FROM"></label>
          </td-wb-input-group-label>
          <td-wb-input-group-field class="td-wb-input-group-field">
            <input id="range-selector-calendar-from-1"
                   class="td-wb-date-range-picker__input"
                   [class.td-wb-date-range-picker__input--active]="picker.getActiveCalendarKey() === 'startDate' && calendarStyle === 'compact'"
                   name="range-selector-calendar-from-1"
                   type="text"
                    [(ngModel)]="startDate"
                   [tdWbDateRangeStartDatePicker]="picker"
                   [minDate]="minCustomDate()"
                   [maxDate]="maxCustomDate()"
                   [required]="true"
                   aria-required="true"
                   tdWbInput>
            <td-wb-input-errors errorKeyNamespace="tdWb.calendar.errors.invalidDate"
                                [multiLine]="true" />
          </td-wb-input-group-field>
        </td-wb-input-group>
      </td-wb-form-row>
      <td-wb-form-row class="td-wb-date-range-picker__row">
        <td-wb-input-group labelPosition="top">
          <td-wb-input-group-label>
            <label for="range-selector-calendar-to-1"
                   translate="tdWb.calendar.TO"></label>
          </td-wb-input-group-label>
          <td-wb-input-group>
            <td-wb-input-group-field class="td-wb-input-group-field">
              <input
                id="range-selector-calendar-to-1"
                class="td-wb-date-range-picker__input"
                [class.td-wb-date-range-picker__input--active]="picker.getActiveCalendarKey() === 'endDate' && calendarStyle === 'compact'"
                name="range-selector-calendar-to-1"
                type="text"
                 [(ngModel)]="endDate"
                [tdWbDateRangeEndDatePicker]="picker"
                [minDate]="minCustomDate()"
                [maxDate]="maxCustomDate()"
                [required]="true"
                aria-required="true"
                tdWbInput/>
              <td-wb-input-group-suffix>
                @if (calendarStyle === 'regular') {
                  <button tdWbButton
                          class="td-wb-date-range-picker__button"
                          id="td-wb-datepicker-set-button"
                          type="submit">
                    <span translate="tdWb.calendar.SUBMIT"></span>
                  </button>
                }
              </td-wb-input-group-suffix>
              <td-wb-input-errors errorKeyNamespace="tdWb.calendar.errors.invalidDate"
                                  [multiLine]="true" />
            </td-wb-input-group-field>
          </td-wb-input-group>
        </td-wb-input-group>
      </td-wb-form-row>
    </div>
    @if (calendarStyle === 'compact') {
      <div class="td-wb-date-range-picker__calendar">
        <ng-container *ngTemplateOutlet="picker.dateContent()" />
      </div>
    }
    @if (calendarStyle === 'compact') {
      <td-wb-divider class="td-wb-date-range-picker__divider" />
    }
    @if (calendarStyle === 'compact') {
      <div class="td-wb-date-range-picker__button--compact">
        <button tdWbButton
                id="td-wb-datepicker-set-button-2"
                type="submit">
          <span translate="tdWb.calendar.SUBMIT"></span>
        </button>
      </div>
    }
  </td-wb-form>
</td-wb-range-selector-calendar>


